import { Component, Input, OnInit } from "@angular/core";
import { APGTestingService } from "../agptesting-newview/apgtesting.service";
import { MasterDataService } from "../masterdata/masterdata.service";
import { LabMDM, SelectableLab } from "../masterdata/models/lab";
import { OperetionHistoryDTO } from "../masterdata/models/operationHistory";
import { SnpProfile } from "../masterdata/models/snp-profile";
import { MessagesService } from "../messages/messages.service";
import { ErrorHandler } from "../utils/error-handler";


@Component({
    selector: 'app-mdm-snp-profile',
    templateUrl: './mdm-snp-profile.html',
    styleUrls: ['./mdm-snp-profile.css']
  })
export class MdmSnpProfileComponent implements OnInit {
  @Input() masterLists: SnpProfile[];
  @Input() tableCols: any[];
  @Input() title: string;
  @Input() labOptions: LabMDM[];
  @Input() checkSelectedLab: SelectableLab;
  selectedMasterList:SnpProfile;
  isNewMasterList: boolean;
  masterList: SnpProfile;
  selectedLabName: string;
  selectedLab: LabMDM;
  uploadedFile: any;
  disableDownloadTagsButton:boolean= true;
  disableDownloadPlateButton:boolean= true;
  uploadedFileName: string;
  uploadedSize: number;
  displayMasterListDialog: boolean = false;
  errorHandler: ErrorHandler = new ErrorHandler;
  puid = localStorage.getItem('PUID');
  labOption: LabMDM[] = [];
  dialogBoxSnp: boolean = false;
  blocked = false;
  constructor(private _messageService: MessagesService, private _masterDataService: MasterDataService, private apgTestingService: APGTestingService) { }

    ngOnInit() {
      this.getActiveOptionsForDropdowns();
    }  


       //Display Add Dialog upon clicking Add button
   showDialogToAddMasterList() {
    this.isNewMasterList = true;
    this.masterList = new SnpProfile;
    this.uploadedFile = null;
    this.uploadedSize=null;
    this.displayMasterListDialog = true;
    this.getActiveOptionsForDropdowns();
    this.uploadedFileName="";
  }

  onRowSelect(event) {
    this.isNewMasterList = false;
    this.masterList = this.cloneMasterList(event.data);
    this.uploadedFileName=this.masterList.fileName;
    this.uploadedSize=this.masterList.profileLength;
    this.displayMasterListDialog = true;
    this.getActiveOptionsForDropdowns();
  }

  getActiveOptionsForDropdowns(): any {
    this.labOption=[];
    this._masterDataService.getLabs(true).subscribe(
      resultLabs => {
        if (!resultLabs) {
          return;
        }  
        let checkSelectedLabName = this.checkSelectedLab.lab.name;
        this.labOptions = resultLabs.data;
        this.labOptions.forEach(lab => {
          
          if(lab.name == checkSelectedLabName) {
            this.labOption.push(lab);
          }
          if (this.masterList && this.masterList.lab && lab._id == this.masterList.lab._id) {
            this.selectedLabName = this.masterList.lab.name;
            this.selectedLab = lab;
          }
        })
        this.labOptions= this.labOption;
        if (!this.masterList || !this.masterList.lab || this.selectedLabName != this.masterList.lab.name)
          this.selectedLab = null;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
        }
    );

  }


  //Insert or update Template
  saveMasterList() { 
    let masterLists = [...this.masterLists];
    if (this.isNewMasterList) {
      this.saveMasterData(masterLists);
    }else{
      if(this.uploadedFile!=null){
        this.confirmUpdateFile();
      }else{
        this.updateMasterList(masterLists)
      }
    }

  }

    //Inserts a new Template in DB
    saveMasterData(masterLists: any[]) {
      this.masterList.lab = new LabMDM();
      this.masterList.lab = this.selectedLab;
      this.masterList.fileName=this.uploadedFileName;
      this.appendHistory("SNP Profile");
      const formData = new FormData();
      formData.append('uploadFile', this.uploadedFile);
      formData.append('snpDTO', new Blob([JSON.stringify(this.masterList)],{type: "application/json"}));   
      this.blocked = true;
      this._masterDataService.addSNPProfile(formData).subscribe(
        snpProfileSave => {
          if (!snpProfileSave) {
            return;
          }
          masterLists = [...this.masterLists];
          masterLists.push(snpProfileSave.data);
          this.masterLists = masterLists;
          this.masterList = null;
          this.uploadedFile=null;
          this.blocked =false;
          this.displayMasterListDialog = false;
          this._messageService.addSuccessMessage({ severity: 'success', summary: 'Saved SNP Profile!', detail: 'SNP Profile is created.' });
        },
        error => {
          this.handleError(error);
        }
      );

    }

  confirmUpdateFile() {
    this.displayMasterListDialog=false;
    this.dialogBoxSnp=true;
  }

  updateSNPData() { 
    let masterLists = [...this.masterLists];
    this.masterList.fileName=this.uploadedFileName;    
    this.updateMasterList(masterLists);
  }

   updateMasterList(masterLists: any[]){
    this.masterList.lab = new LabMDM();
    this.masterList.lab = this.selectedLab;
    this.appendHistory("SNP Profile");
    this.blocked = true;
    const formData = new FormData();
    formData.append('uploadFile', this.uploadedFile);
    formData.append('snpDTO', new Blob([JSON.stringify(this.masterList)],{type: "application/json"}));
    this._masterDataService.updateSNPProfile(formData).subscribe(
      results => {
        if (!results) {
          return;
        }
        masterLists[this.masterLists.indexOf(this.selectedMasterList)] = results.data;
        this.masterLists = masterLists;
        this.masterList = null;
        this.displayMasterListDialog = false;
        this._messageService.addSuccessMessage({ severity: 'success', summary: 'Updated SNP Profile!', detail: 'SNP Profile is Updated.' });
        this.blocked = false;
        this.uploadedFile=null;
        this.dialogBoxSnp=false // Add this line alone
        this.displayMasterListDialog = false;
      },
      error => {
        this.handleError(error);
        }
    );

   }
    onsnpProfileUpload(event , fileUploader: any){
      if(event.files[0].name.split('.').pop() !== "csv"){
        this._messageService.addErrorMessage({
          severity: 'error', summary: 'Invalid File Type!!',
          detail: 'Only .csv files are allowed.',
        });
        return;
      }
      this.uploadedFile = event.files[0];
      this.uploadedFileName = this.uploadedFile.name;
      fileUploader.clear();
    }

    cloneMasterList(list: any): any {
      let masterList = {};
      for (let prop in list) {
        masterList[prop] = list[prop];
      }
      return masterList;
    }

    isSaveDisabled() {
      return !(this.masterList && this.masterList.snpProfileName && this.selectedLab && (this.uploadedFileName || this.uploadedSize));
    }

    private handleError(error: any) {
      this.blocked = false;
      let message = this.errorHandler.handleError(error);
      this._messageService.addErrorMessage(message);
    }
  
    appendHistory(tabName: string){
      let historyObj:OperetionHistoryDTO = new OperetionHistoryDTO();
      historyObj.puid = this.puid;
      historyObj.operationDateTime = new Date();
      historyObj.tabName = tabName;
      if(this.masterList.history){
        this.masterList.history.push(historyObj);
      } else {
        this.masterList.history = [];
        this.masterList.history.push(historyObj);
      }
    }
}